// Generated by Melange

import * as Buhta_dictapis__Buhta_dict_v1alpha1_kogd from "./buhta_dict_v1alpha1_kogd.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const ListOgdCodesRequest = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_kogd_service.ml",
  290,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListOgdCodesResponse = Caml_module.init_mod([
  "proto/dictapis/gen/buhta_dict_v1alpha1_kogd_service.ml",
  350,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.dict.v1alpha1.ListOgdCodesRequest";
}

function make(effective_date, param) {
  return {
    effective_date: effective_date
  };
}

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_effective_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "effective_date",
    "effectiveDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge(t1, t2) {
  return {
    effective_date: Curry._2(merge_effective_date, t1.effective_date, t2.effective_date)
  };
}

function spec(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "effective_date",
      "effectiveDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.effective_date);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(effective_date) {
  return {
    effective_date: effective_date
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1alpha1.ListOgdCodesRequest", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.effective_date);
  };
}

function constructor$1(effective_date) {
  return {
    effective_date: effective_date
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1alpha1.ListOgdCodesRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListOgdCodesRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.dict.v1alpha1.ListOgdCodesResponse";
}

function make$1(codesOpt, param) {
  const codes = codesOpt !== undefined ? codesOpt : /* [] */ 0;
  return {
    codes: codes
  };
}

const $$let$1 = Buhta_dictapis__Buhta_dict_v1alpha1_kogd.Buhta.Dict.V1alpha1.Kogd;

const merge_codes = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "codes",
    "codes"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$1(t1, t2) {
  return {
    codes: Curry._2(merge_codes, t1.codes, t2.codes)
  };
}

function spec$1(param) {
  const $$let = Buhta_dictapis__Buhta_dict_v1alpha1_kogd.Buhta.Dict.V1alpha1.Kogd;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "codes",
      "codes"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.codes);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(codes) {
  return {
    codes: codes
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.dict.v1alpha1.ListOgdCodesResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.codes);
  };
}

function constructor$3(codes) {
  return {
    codes: codes
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.dict.v1alpha1.ListOgdCodesResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListOgdCodesResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

const listOgdCodes_0 = {
  name: ListOgdCodesRequest.name,
  make: ListOgdCodesRequest.make,
  from_proto: ListOgdCodesRequest.from_proto,
  from_proto_exn: ListOgdCodesRequest.from_proto_exn,
  to_proto: ListOgdCodesRequest.to_proto,
  to_proto$p: ListOgdCodesRequest.to_proto$p,
  merge: ListOgdCodesRequest.merge,
  to_json: ListOgdCodesRequest.to_json,
  from_json_exn: ListOgdCodesRequest.from_json_exn,
  from_json: ListOgdCodesRequest.from_json
};

const listOgdCodes_1 = {
  name: ListOgdCodesResponse.name,
  make: ListOgdCodesResponse.make,
  from_proto: ListOgdCodesResponse.from_proto,
  from_proto_exn: ListOgdCodesResponse.from_proto_exn,
  to_proto: ListOgdCodesResponse.to_proto,
  to_proto$p: ListOgdCodesResponse.to_proto$p,
  merge: ListOgdCodesResponse.merge,
  to_json: ListOgdCodesResponse.to_json,
  from_json_exn: ListOgdCodesResponse.from_json_exn,
  from_json: ListOgdCodesResponse.from_json
};

const listOgdCodes = [
  listOgdCodes_0,
  listOgdCodes_1
];

const V1alpha1_KogdService = {
  ListOgdCodes: {
    name: "/buhta.dict.v1alpha1.KogdService/ListOgdCodes",
    package_name: "buhta.dict.v1alpha1",
    service_name: "KogdService",
    method_name: "ListOgdCodes",
    $$Request: {
      name: ListOgdCodesRequest.name,
      make: ListOgdCodesRequest.make,
      from_proto: ListOgdCodesRequest.from_proto,
      from_proto_exn: ListOgdCodesRequest.from_proto_exn,
      to_proto: ListOgdCodesRequest.to_proto,
      to_proto$p: ListOgdCodesRequest.to_proto$p,
      merge: ListOgdCodesRequest.merge,
      to_json: ListOgdCodesRequest.to_json,
      from_json_exn: ListOgdCodesRequest.from_json_exn,
      from_json: ListOgdCodesRequest.from_json
    },
    $$Response: {
      name: ListOgdCodesResponse.name,
      make: ListOgdCodesResponse.make,
      from_proto: ListOgdCodesResponse.from_proto,
      from_proto_exn: ListOgdCodesResponse.from_proto_exn,
      to_proto: ListOgdCodesResponse.to_proto,
      to_proto$p: ListOgdCodesResponse.to_proto$p,
      merge: ListOgdCodesResponse.merge,
      to_json: ListOgdCodesResponse.to_json,
      from_json_exn: ListOgdCodesResponse.from_json_exn,
      from_json: ListOgdCodesResponse.from_json
    }
  },
  listOgdCodes: listOgdCodes
};

const V1alpha1 = {
  ListOgdCodesRequest: ListOgdCodesRequest,
  ListOgdCodesResponse: ListOgdCodesResponse,
  KogdService: V1alpha1_KogdService
};

const Dict = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Dict: Dict
};

export {
  Imported$pmodules,
  Buhta,
}
/* ListOgdCodesRequest Not a pure module */
